import React from "react";
import { SearchIcon } from "../assets/svgs/Icons";
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
  Tab,
  Table,
  TableCaption,
  TableContainer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Tbody,
  Td,
  Text,
  Tfoot,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import isAllowed from "../routing/isAllowed";

function Certificates() {
  const navigate = useNavigate();
  return (
    <Box paddingTop={"9rem"}>
      <Flex gap={"20"} alignItems={"center"} justifyContent={"space-between"}>
        <Box>
          {" "}
          <Text color="brand.blue" fontSize="28px" fontWeight={"600"}>
            Transaction Certificates
          </Text>
        </Box>
        <Box marginRight={"10rem"}>
          <Button
            w="120px"
            bg="#52BBFF"
            color={"#fff"}
            _hover={{ bg: "#52BBFF" }}
            onClick={() => navigate("/tc-form")}
          >
            Add TC
          </Button>
        </Box>
      </Flex>
      <Box marginTop={"2rem"}>
        <Tabs size="md" variant="enclosed">
          <TabList marginLeft={"1rem"}>
            <Tab
              transition={"all 0.3s ease-in-out"}
              _selected={{ bg: "white" }}
            >
              Outgoing
            </Tab>
            <Tab
              transition={"all 0.3s ease-in-out"}
              _selected={{ bg: "white" }}
            >
              Incoming
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <TableContainer
                marginTop={"-1rem"}
                className="overflow-style"
                overflowX={"scroll"}
              >
                <Table
                  size="lg"
                  bg="brand.white"
                  borderRadius="15px"
                  borderTopLeftRadius={"0px"}
                >
                  <Thead fontStyle={"normal"}>
                    <Tr fontStyle={"normal"}>
                      <Th color="brand.blue" textTransform="capitalize">
                        Sr No.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Date
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Company Name
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Company ID
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        TC Number
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Unit Number
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Quantity
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        UOM
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Unit No.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Status
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>1</Td>
                      <Td>1/1/2023</Td>
                      <Td>Sakharam Gathne</Td>
                      <Td>1234</Td>
                      <Td>100kg</Td>
                      <Td>003</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td color="brand.lightGreen" fontWeight={"700"}>
                        Approved
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>1</Td>
                      <Td>1/1/2023</Td>
                      <Td>Sakharam Gathne</Td>
                      <Td>1234</Td>
                      <Td>100kg</Td>
                      <Td>003</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td color="brand.alertRed" fontWeight={"700"}>
                        Rejected
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </TabPanel>
            <TabPanel>
              <TableContainer
                marginTop={"-1rem"}
                className="overflow-style"
                overflowX={"scroll"}
              >
                <Table
                  size="lg"
                  bg="brand.white"
                  borderRadius="15px"
                  borderTopLeftRadius={"0px"}
                >
                  <Thead fontStyle={"normal"}>
                    <Tr fontStyle={"normal"}>
                      <Th color="brand.blue" textTransform="capitalize">
                        Sr No.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Date
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Company Name
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Company ID
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        TC Number
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Unit Number
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Quantity
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        UOM
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Unit No.
                      </Th>
                      <Th color="brand.blue" textTransform="capitalize">
                        Status
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td>2</Td>
                      <Td>1/1/2023</Td>
                      <Td>Sakharam Gathne</Td>
                      <Td>1234</Td>
                      <Td>100kg</Td>
                      <Td>003</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td color="brand.lightGreen" fontWeight={"700"}>
                        Approved
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>2</Td>
                      <Td>1/1/2023</Td>
                      <Td>Sakharam Gathne</Td>
                      <Td>1234</Td>
                      <Td>100kg</Td>
                      <Td>003</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td>100% Consumed</Td>
                      <Td color="brand.alertRed" fontWeight={"700"}>
                        Rejected
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Box>
  );
}

export default isAllowed(Certificates);
